module.exports = __webpack_public_path__ + "assets/img/38-l.ce4f48c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/38-l.jpg
// module id = OB9c
// module chunks = 0